const RUNTIME_CONFIG_KEY = "__MAXIS_RUNTIME_CONFIG__";

export const getRuntimeConfig = () => {
  if (typeof window === "undefined") return {};
  return window[RUNTIME_CONFIG_KEY] || {};
};

export const getRuntimeConfigValue = (key, fallback = "") => {
  const runtimeConfig = getRuntimeConfig();
  return runtimeConfig[key] ?? fallback;
};
